import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Jessica from "../pages/jessica/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Jessica />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
